import React from 'react';
import {CloseOutlined} from '@ant-design/icons';
import {Button, Col, Input, message, Modal, Row, Select, Spin} from 'antd';
import {connect} from 'react-redux'
import cookie from "react-cookies";
import {responsiveLayers} from "../../utils/const";
import {get} from "../../helper/request";
import {isCloud} from "../../utils/utils";
import { addSlidesToCase } from 'utils/api';
import {performAbortControllerSlideSearch} from "utils/api";


class SlideSuggestions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            inputValue: '',
            name_suggestions: [],
            selectedSlideList: [],
            loadingSlideSearchResults: false,
        }

        this.is_cloud = isCloud();
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
        this.iOS = cookie.loadAll().iOS === "true";
    }

    updateSlideSearchResults = (data) => {
        if(data.length > 0){
            let res_list = [];
            if (this.state.selectedSlideList.length > 0) {
                for (let j = 0; j < data.length; j++) {
                    if (this.state.selectedSlideList.findIndex((item) => data[j].id === item.id) === -1) {
                        res_list.push(data[j]);
                    }
                }
            } else {
                res_list = data;
            }
            this.setState({
                name_suggestions: res_list,
                loadingSlideSearchResults: false,
            });
        }else{
            this.setState({
                name_suggestions: [],
                loadingSlideSearchResults: false,
            })
        }
    }

    performSlideSearch = (value) => {
        this.setState({
            loadingSlideSearchResults: true,
            inputValue: value,
        });
        performAbortControllerSlideSearch(value, this.updateSlideSearchResults);
    }

    selectSlide = (values) => {
        if (values.length > 0 || values >= 0) {
            let val = {
                id: values.split(',')[0],
                name: values.split(',')[1],
            }
            let selectedSlideList = this.state.selectedSlideList;
            selectedSlideList.unshift(val);
            this.setState({
                selectedSlideList,
                inputValue: '',
                name_suggestions: [],
            });
        } else {
            this.setState({
                inputValue: '',
                name_suggestions: [],
                selectedSlideList: '',
            });
        }
    }

    onBlurAction = (values) => {
        this.setState({
            inputValue: '',
            name_suggestions: [],
        });
    }

    removeSlide = (slide) => {
        let selectedSlideList = this.state.selectedSlideList;
        let index = selectedSlideList.findIndex((item) => slide.id === item.id);
        selectedSlideList.splice(index, 1);
        this.setState({
            selectedSlideList,
            inputValue: '',
            name_suggestions: [],
        });
    }

    handleOk = () => {
        if (this.state.selectedSlideList.length > 0) {
            addSlidesToCase(this.props.currCase.case_id, this.state.selectedSlideList)
                .then(response => {
                    if (response.status === 200 || response.status === 301 || response.status === 302) {
                        message.success("Slides added successfully.", 2.5);
                    } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                        message.error("Some error occured. Not able to assign a case.", 2.5);
                        console.log(response);
                    }
                    this.props.closeModal();
                    this.setState({
                        inputValue: '',
                        name_suggestions: [],
                        selectedSlideList: [],
                    });
                })
                .catch(err => {
                    this.props.closeModal();
                    message.error("Some error occured. Not able to assign a case.", 2.5);
                    console.log(err);
                    this.setState({
                        inputValue: '',
                        name_suggestions: [],
                        selectedSlideList: [],
                    });
                });
        } else {
            message.error("Please select atleast 1 slide to add.", 2.5);
            this.setState({
                inputValue: '',
                name_suggestions: [],
                selectedSlideList: [],
            });
        }
    }

    handleCancel = () => {
        this.props.closeModal();
        this.setState({
            inputValue: '',
            name_suggestions: [],
            selectedSlideList: [],
        });
    }

    render() {

        let selected = [];

        let numSuggested = this.state.name_suggestions.length;

        let slideSuggestionsBox = numSuggested > 0 || this.state.loadingSlideSearchResults ?
            <Select.OptGroup label={this.state.loadingSlideSearchResults ?  <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading Results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {this.state.name_suggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.id + ',' + item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        <span className={'preserve-white-space'}>{item.display_text}</span><span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> : undefined;

        return (
            <Modal
                title={"Add Slide"}
                visible={this.props.modalVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                okButtonProps={{disabled: !(this.state.selectedSlideList.length > 0)}}
            >
                <div>
                    {this.state.selectedSlideList.length > 0 ?
                        <div>
                            <Row>
                                <Col span={23} offset={1} push={8}>
                                    <div>
                                        <b>{this.state.selectedSlideList.length}</b> SLIDE{this.state.selectedSlideList.length > 1 ? 'S' : ''} SELECTED
                                    </div>
                                </Col>
                            </Row>
                            <br/>
                        </div> : null
                    }
                    <div className={this.state.selectedSlideList.length > 3 ? "scroll-slide-list-modal" : ""}>
                        {this.state.selectedSlideList.map((slide, index) => {
                            return (
                                <div key={index}>
                                    <Row>
                                        <Col span={14} offset={3}>
                                            <Input style={{color: "black", cursor: "default"}}
                                                   value={slide.name}
                                                   disabled
                                            />
                                        </Col>
                                        <Col span={6} offset={1} style={{paddingTop: 5}}>
                                            <Button
                                                type="danger"
                                                onClick={() => this.removeSlide(slide)}
                                                ghost
                                                size="small"
                                            >
                                                <CloseOutlined/>
                                            </Button>
                                        </Col>
                                    </Row>
                                    <br/>
                                </div>
                            );
                        })}
                    </div>
                    <br/>
                    <Row>
                        <Col offset={1}>
                            <p>Please enter Slide name in the input box below.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col id={'add-slide-search-select'} className={'custom-dropdown-max-height'} offset={1}>
                            <Select
                                showSearch
                                allowClear
                                autoFocus
                                placeholder="Enter slide name"
                                className="search-input"
                                showArrow={false}
                                filterOption={false}
                                notFoundContent={null}
                                onSearch={this.performSlideSearch}
                                onSelect={this.selectSlide}
                                onBlur={this.onBlurAction}
                                optionLabelProp="label"
                                value={selected}
                                getPopupContainer={() => document.getElementById('add-slide-search-select')}
                            >
                                {slideSuggestionsBox}
                            </Select>
                        </Col>
                    </Row>
                </div>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchReducer,
        allSlides: state.slidesReducer
    }
}

export default connect(mapStateToProps)(SlideSuggestions);
